<div class="flex items-center justify-center dialog-header ">

    Add Enrollment

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div class="p-4">
        <form #leadForm="ngForm" (ngSubmit)="onSubmit(leadForm.form.valid)">

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Prefix</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['prefix']" name="prefix"
                        [options]="prefixOptions"></p-select>
                </div>



                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">First Name</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;" #first_name="ngModel"
                        pattern="^[a-zA-Z0-9 ]*$" [(ngModel)]="createFieldFormValue['first_name']" name="first_name"
                        required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['first_name']}" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['first_name']">Enter First
                        Name</small>
                    <small class="text-red-500" *ngIf="first_name?.errors?.['pattern']">
                        Special characters are not allowed.
                    </small>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Last Name</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['last_name']" name="last_name" required #last_name="ngModel"
                        pattern="^[a-zA-Z0-9 ]*$"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['last_name'] }" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['last_name']">Enter Last
                        Name</small>
                    <small class="text-red-500" *ngIf="last_name?.errors?.['pattern']">
                        Special characters are not allowed.
                    </small>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Contact Email</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['email']" name="email" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['email']}" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['email']">Enter Contact
                        Email</small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 ">Enrollment Owner</label>
                    <p-select appendTo="body" class="w-full"
                        [(ngModel)]="createFieldFormValue.enrollment_data.assign_to" name="assigned_to"
                        [options]="users"></p-select>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Contact Number</label>
                    <!-- <input pInputText class="w-1/4" type="number" style="box-shadow: none !important;"
                            placeholder="code" [(ngModel)]="createFieldFormValue['country_code']" name="country_code"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['country_code'] }"
                            required /> -->
                    <input pInputText type="number" class="w-full" style="box-shadow: none !important;"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['contact_phone'] }"
                        [(ngModel)]="createFieldFormValue['contact_phone']" name="contact_phone" required />
                    <small class="text-red-500" *ngIf="isSubmitted && (!createFieldFormValue['contact_phone']
                    )">Enter Contact Number</small>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Alternate Number</label>
                    <!-- <input pInputText class="w-1/4" type="number" style="box-shadow: none !important;"
                            placeholder="code" [(ngModel)]="createFieldFormValue['alternate_code']"
                            name="alternate_code" /> -->
                    <input pInputText type="number" class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['alternate_phone']" name="alternate_phone" />
                </div>



                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Date of Birth</label>
                    <p-datepicker class="w-full" appendTo="body" [inputStyle]="{
                        'box-shadow':'none !important',
                        'width': '100%'
                    }" [style]="{'box-shadow':'none !important',
                        'width': '100%'
                     }" [maxDate]="today" [(ngModel)]="createFieldFormValue['date_of_birth']" name="date_of_birth" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Age</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['age']" name="age" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Gender</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['gender']" name="gender"
                        [options]="genderOptions" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Nationality</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['nationality']" name="nationality" />
                </div>


                <!-- <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Interested Course</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['interested_course']" name="interested_course" />
                </div> -->

                <!-- <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Preferred Location</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['preferred_location']" name="preferred_location" />
                </div> -->

                <!-- city state -->
                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">City</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['city']" name="city" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">State</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['state']" name="state" />
                </div>


                <!-- country postal_code -->

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Country</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['country']" name="country" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Postal Code</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['postal_code']" name="postal_code" />
                </div>

            </div>

            <div class="grid grid-cols-1 mt-4">
                <div class="col-span-1">
                    <label class="block mb-2">Address</label>
                    <textarea pTextarea class="w-full" rows="5" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['address']" name="address"></textarea>
                </div>

            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
                <!-- <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Status</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue.reg_data.status" name="lead_status"
                        [options]="registrationStatusList" required [ngClass]="{
                            'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.reg_data?.status
                        }">
                    </p-select>

                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue.reg_data?.status">
                        Select Status
                    </small>
                </div> -->

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Guardian Name</label>
                    <input pInputText class="w-full shadow-none"
                        [(ngModel)]="createFieldFormValue.enrollment_data.guardian_name" name="guardian_name" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Guardian Contact</label>
                    <input pInputText class="w-full shadow-none"
                        [(ngModel)]="createFieldFormValue.enrollment_data.guardian_contact" name="guardian_contact"
                        type="number" placeholder="Enter Guardian Phone Number" />
                </div>
                <!-- 
                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Previous Education</label>
                    <input pInputText class="w-full shadow-none"
                        [(ngModel)]="createFieldFormValue.enrollment_data.previous_education" name="previous_education"
                        type="text" />
                </div> -->

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Preferred Course</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue.enrollment_data.course_id" name="course_id" optionLabel="name"
                        optionValue="course_id" [options]="allCourses" required [ngClass]="{
                            'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.enrollment_data?.course_id
                        }">
                    </p-select>

                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.course_id">
                        Select Preferred Course
                    </small>
                </div>


                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Source</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue.source" name="source"
                        [options]="leadSources" required [ngClass]="{
                'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue?.source
            }"></p-select>

                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue?.source">Select
                        Source</small>

                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Enrollment Status</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue.enrollment_data.enrollment_status" name="lead_status"
                        [options]="enrollmentStatusList" required [ngClass]="{
                    'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue?.enrollment_data?.enrollment_status
                }"></p-select>

                    <small class="text-red-500"
                        *ngIf="isSubmitted && !createFieldFormValue?.enrollment_data?.enrollment_status">Select Enrollment
                        Status</small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Document Status</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue.enrollment_data.document_status" name="document_status"
                        [options]="documentStatusList" required [ngClass]="{
                            'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.enrollment_data?.document_status
                        }">
                    </p-select>

                    <small class="text-red-500"
                        *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.document_status">
                        Select Document Status
                    </small>
                </div>

                   <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Mode of Study</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue.enrollment_data.mode_of_study" name="mode_of_study"
                        [options]="modeOfStudyList" required [ngClass]="{
                            'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.enrollment_data?.mode_of_study
                        }">
                    </p-select>

                    <small class="text-red-500"
                        *ngIf="isSubmitted && !createFieldFormValue.enrollment_data?.mode_of_study">
                        Select Mode of Study
                    </small>
                </div>

            </div>

            <div class="grid grid-cols-1 mt-4">
                <div class="col-span-1">
                    <label class="block mb-2">Remarks</label>
                    <textarea pTextarea class="w-full" rows="5" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['remarks']" name="remarks"></textarea>
                </div>

            </div>


            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">

                <div class="" *ngFor="let item of allLeadFeilds">
                    <div class="col-span-1 w-full">
                        <label class="block mb-2" [ngClass]="{ 'requiredValue': item.required }">{{ item.label
                            }}</label>
                        <input pInputText *ngIf="item.type !== 'select' && item.type !== 'textarea'" class="w-full"
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            style="box-shadow: none !important;" [required]="item.required === true ? true : false "
                            [ngModelOptions]="{ standalone: false }" placeholder="{{ item.placeholder }}" [ngClass]="{
                    'ng-invalid ng-dirty' : isSubmitted && item.required && !fieldValues[item.field_name]
                }" />
                        <textarea pTextarea *ngIf="item.type === 'textarea'" style="box-shadow: none !important;"
                            class="w-full" [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [ngModelOptions]="{ standalone: false }" [required]="item.required === true ? true : false "
                            placeholder="{{ item.placeholder }}"></textarea>
                        <p-select *ngIf="item.type === 'select'" class="w-full" appendTo="body"
                            [ngModelOptions]="{ standalone: false }" [required]="item.required === true ? true : false "
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [options]="item.data" [placeholder]="item.placeholder"></p-select>
                        <small class="text-red-500"
                            *ngIf="isSubmitted && item.required && !fieldValues[item.field_name]">Enter {{ item.label
                            }}</small>
                    </div>
                </div>

            </div>

            <!-- <div class="col-span-1" *ngIf="isAdmin">
            <label class="block mb-2">Editable For All Users</label>
            <p-dropdown class="w-full" [(ngModel)]="createFieldFormValue['isEdit']" name="isEdit" [options]="[{label: 'True', value: true}, {label: 'False', value: false}]" required></p-dropdown>
          </div> -->


            <div class="mt-4">
                <p-button [label]="formAction === 'Add' ? 'Save' : 'Update'"
                    [icon]="formAction === 'Add' ? 'pi pi-save' : 'pi pi-pencil'" [disabled]="isLoading"
                    [loading]="isLoading" type="submit" class="p-button-primary w-full md:w-auto"></p-button>
            </div>
        </form>
    </div>
</div>